import {NgModule} from '@angular/core';
import {ProductOrderComponent} from './product-order/product-order.component';
import {MobileRoutingModule} from './mobile-routing.module';
import {AgGridModule} from "ag-grid-angular";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";
import {MatIconModule} from "@angular/material/icon";
import {CommonModule} from "@angular/common";
import {MatTabsModule} from "@angular/material/tabs";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { DeliveryComponent } from './delivery/delivery.component';
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";


@NgModule({
  declarations: [
    ProductOrderComponent,
    DeliveryComponent
  ],
  exports: [],
  imports: [
    MobileRoutingModule,
    AgGridModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
    MatIconModule,
    CommonModule,
    MatTabsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatInputModule
  ]
})
export class MobileModule {}
